if (!customElements.get('momento-comparison-reviews')) {
  class MomentoComparisonReviews extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.heading = this.querySelector('[data-marker-heading]');
      this.filterButton = this.querySelector('[data-review-filter-button]');
      this.filterPopover = this.querySelector('[data-review-filter-popover]');
      this.ratingSelect = this.querySelector('[data-review-rating]');
      this.tabButtons = Array.from(this.querySelectorAll('[data-review-tab]'));
      this.abortController = new AbortController();
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.abortController.signal;

      this.filterButton?.addEventListener('click', () => {
        this.setFilterOpen(this.filterButton.getAttribute('aria-expanded') !== 'true');
      }, { signal });

      this.filterPopover?.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.setFilterOpen(false);
        this.filterButton?.focus();
      }, { signal });

      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectTab(button), { signal });
      });

      this.ratingSelect?.addEventListener('change', () => this.emitReviewState(), { signal });

      this.motionPreference.addEventListener('change', () => this.syncMotion(), { signal });
      this.dataset.activeReviewTab = this.querySelector('[data-review-tab][aria-selected="true"]')?.dataset.reviewTab || 'product';
      this.dataset.selectedReviewRating = this.ratingSelect?.value || 'All ratings';
      this.syncMotion();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
      this.abortController = null;
    }

    syncMotion() {
      this.observer?.disconnect();
      if (!this.heading) return;

      if (this.motionPreference.matches) {
        this.heading.classList.add('is-drawn');
        return;
      }

      if (this.heading.classList.contains('is-drawn')) return;

      this.observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        this.heading.classList.add('is-drawn');
        this.observer.disconnect();
      }, {
        rootMargin: '0px 0px -12%',
        threshold: 0.35,
      });
      this.observer.observe(this.heading);
    }

    setFilterOpen(open) {
      if (!this.filterButton || !this.filterPopover) return;
      this.filterButton.setAttribute('aria-expanded', String(open));
      this.filterPopover.hidden = !open;
    }

    selectTab(selectedButton) {
      this.tabButtons.forEach((button) => {
        const isSelected = button === selectedButton;
        button.classList.toggle('is-active', isSelected);
        button.setAttribute('aria-selected', String(isSelected));
      });
      this.dataset.activeReviewTab = selectedButton.dataset.reviewTab;
      this.emitReviewState();
    }

    emitReviewState() {
      this.dataset.selectedReviewRating = this.ratingSelect?.value || 'All ratings';
      this.dispatchEvent(new CustomEvent('momento:review-state', {
        detail: {
          tab: this.dataset.activeReviewTab || 'product',
          rating: this.dataset.selectedReviewRating,
        },
      }));
    }
  }

  customElements.define('momento-comparison-reviews', MomentoComparisonReviews);
}
